module.exports = __webpack_public_path__ + "img/my.b977463a.svg";